<template>
    <div id="app"
    >
        <div class="loading-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage"
            >
                <h3 v-if="browserDetect.isIE || browserDetect.isEdge">{{ $t('message.Loading') }}</h3>
            </loading>
        </div>
        <div class="container headerOffset">
            <div class="row">
                <div class="breadcrumbDiv col-lg-12">
                    <ul class="breadcrumb">
                        <li><a href="/">Home</a></li>
                        <li>
                            {{ $t('message.Catalogo') }}
                        </li>

                        <li v-if="queryParams.top">
                            <a
                                    v-on:click="removeFilters(['category' , 'brand'])"
                            >
                                {{getChipTranslation(queryParams.top)}}
                            </a>
                        </li>

                        <li v-if="queryParams.category">
                            <a
                                    v-on:click="removeFilters(['group','brand'])"
                            >
                                {{getChipTranslation(queryParams.category)}}
                            </a>
                        </li>

                        <li v-if="queryParams.group">
                            <a
                                    v-on:click="removeFilters(['brand'])"
                            >
                                {{getChipTranslation(queryParams.group)}}
                            </a>
                        </li>

                        <li v-if="queryParams.brand">
                            <a
                                    v-on:click="_setRoute()"
                            >
                                {{getChipTranslation(queryParams.brand)}}
                            </a>
                        </li>


                    </ul>
                </div>
            </div>

            <div class="themeControll active">
                <h3 class="uppercase color-white text-center"> {{ $t('message.Ricerca_prodotti') }} </h3>

                <div class="col-xs-12 menu-container">
                    <div v-if="showTopWidget && menu && menu.tops && menu.tops.length"
                         class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" href="#collapseTop" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span> {{ $t('message.Area') }}
                                </a>
                            </h4>
                        </div>
                        <div id="collapseTop" class="panel-collapse collapse in">
                            <div class="panel-body">
                                <ul class="nav nav-pills nav-stacked tree">
                                    <li class="cat-parent"
                                        is="menu-item"
                                        v-for="(top, index) in menu.tops"
                                        v-bind:key="top.id"
                                        v-bind:menu="top"
                                        v-bind:type="'top'"
                                        v-bind:queryParams="queryParams"
                                        @addFilter="addFilterEvent"
                                    >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="menu && menu.categories_groups && menu.categories_groups.length" class="">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapseCategory" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                        </span>
                                        {{ $t('message.Categorie') }}
                                    </a>
                                </h4>
                            </div>

                            <div id="collapseCategory" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <ul class="nav nav-pills nav-stacked tree">
                                        <li class="active dropdown-tree"
                                            is="menu-item"
                                            ref="menu"
                                            v-for="(category, index) in menu.categories_groups"
                                            v-bind:key="category.id"
                                            v-bind:menu="category"
                                            v-bind:type="'categories_groups'"
                                            @addFilter="addFilterEvent"
                                        >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="menu.brands && menu.brands.length" class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapseBrand" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                        {{ $t('message.Marchi') }}
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseBrand" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <ul class="nav nav-pills nav-stacked tree">
                                        <li class="cat-parent"
                                            is="menu-item"
                                            v-for="(brand, index) in menu.brands"
                                            v-bind:key="brand.id"
                                            v-bind:menu="brand"
                                            v-bind:type="'brands'"
                                            v-bind:queryParams="queryParams"
                                            @addFilter="addFilterEvent"
                                        >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="menu.genders && menu.genders.length" class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapseGender" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                        {{ $t('message.Genere') }}
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseGender" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <ul class="nav nav-pills nav-stacked tree">
                                        <li class="cat-parent"
                                            is="menu-item"
                                            v-for="(gender, index) in menu.genders"
                                            v-bind:key="gender.id"
                                            v-bind:menu="gender"
                                            v-bind:type="'genders'"
                                            v-bind:queryParams="queryParams"
                                            @addFilter="addFilterEvent"
                                        >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div v-if="menu.seasons && menu.seasons.length" class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapseSeason" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                        {{ $t('message.Stagione') }}
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseSeason" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <ul class="nav nav-pills nav-stacked tree">
                                        <li class="cat-parent"
                                            is="menu-item"
                                            v-for="(season, index) in menu.seasons"
                                            v-bind:key="season.id"
                                            v-bind:menu="season"
                                            v-bind:type="'seasons'"
                                            v-bind:queryParams="queryParams"
                                            @addFilter="addFilterEvent"
                                        >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div v-if="showProductsList() && menu.price && minPrice!=maxPrice" class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapsePrice" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                        {{ $t('message.Prezzo') }}
                                    </a>
                                </h4>
                            </div>
                            <div id="collapsePrice" class="panel-collapse collapse in">
                                <br/>
                                <div class="panel-body">
                                    <vue-slider
                                            ref="slider"
                                            :min="startPrice"
                                            :max="endPrice"
                                            v-model="priceSearch"
                                            tooltip="always"
                                            v-on:drag-end="changePrices"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <p class="tbtn"><i class="fa fa-angle-double-left"></i></p>
            </div>

            <div class="row">

                <div class="menuControll col-sm-3 col-xs-12">
                    <div v-if="showTopWidget && menu && menu.tops && menu.tops.length"
                         class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" href="#collapseTop" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                    {{ $t('message.Area') }}
                                </a>
                            </h4>
                        </div>
                        <div id="collapseTop" class="panel-collapse collapse in">
                            <div class="panel-body">
                                <ul class="nav nav-pills nav-stacked tree">
                                    <li class="cat-parent"
                                        is="menu-item"
                                        v-for="(top, index) in menu.tops"
                                        v-bind:key="top.id"
                                        v-bind:menu="top"
                                        v-bind:type="'top'"
                                        v-bind:queryParams="queryParams"
                                        @addFilter="addFilterEvent"
                                    >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="menu && menu.hasOwnProperty('categories_groups') && menu.categories_groups && menu.categories_groups.length"
                         class="">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapseCategory" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                        </span>
                                        {{ $t('message.Categorie') }}
                                    </a>
                                </h4>
                            </div>

                            <div id="collapseCategory" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <ul class="nav nav-pills nav-stacked tree">
                                        <li class="active dropdown-tree"
                                            is="menu-item"
                                            ref="menu"
                                            v-for="(category, index) in menu.categories_groups"
                                            v-bind:key="category.id"
                                            v-bind:menu="category"
                                            v-bind:type="'categories_groups'"
                                            v-bind:queryParams="queryParams"
                                            @addFilter="addFilterEvent"
                                        >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="menu.hasOwnProperty('brands') && menu.brands && menu.brands.length"
                             class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapseBrand" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                        {{ $t('message.Marchi') }}
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseBrand" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <ul class="nav nav-pills nav-stacked tree">
                                        <li class="cat-parent"
                                            is="menu-item"
                                            v-for="(brand, index) in menu.brands"
                                            v-bind:key="brand.id"
                                            v-bind:menu="brand"
                                            v-bind:type="'brands'"
                                            v-bind:queryParams="queryParams"
                                            @addFilter="addFilterEvent"
                                        >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="menu.hasOwnProperty('genders') && menu.brands && menu.genders && menu.genders.length"
                             class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapseGender" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                        {{ $t('message.Genere') }}
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseGender" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <ul class="nav nav-pills nav-stacked tree">
                                        <li class="cat-parent"
                                            is="menu-item"
                                            v-for="(gender, index) in menu.genders"
                                            v-bind:key="gender.id"
                                            v-bind:menu="gender"
                                            v-bind:type="'genders'"
                                            v-bind:queryParams="queryParams"
                                            @addFilter="addFilterEvent"
                                        >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div v-if="menu.hasOwnProperty('seasons') && menu.seasons && menu.seasons.length"
                             class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapseSeason" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                        {{ $t('message.Stagione') }}
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseSeason" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <ul class="nav nav-pills nav-stacked tree">
                                        <li class="cat-parent"
                                            is="menu-item"
                                            v-for="(season, index) in menu.seasons"
                                            v-bind:key="season.id"
                                            v-bind:menu="season"
                                            v-bind:type="'seasons'"
                                            v-bind:queryParams="queryParams"
                                            @addFilter="addFilterEvent"
                                        >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div v-if="showProductsList() && menu.price && minPrice!=maxPrice" class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" href="#collapsePrice" class="collapseWill active ">
                                    <span class="pull-left">
                                        <span class="fa fa-caret-right"></span>
                                    </span>
                                        {{ $t('message.Prezzo') }}
                                    </a>
                                </h4>
                            </div>
                            <div id="collapsePrice" class="panel-collapse collapse in">
                                <br/>
                                <div class="panel-body">
                                    <vue-slider
                                            ref="slider"
                                            :min="startPrice"
                                            :max="endPrice"
                                            tooltip="always"
                                            v-model="priceSearch"
                                            v-on:drag-end="changePrices"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div
                        v-if="!isLoading && !showProductsList() && menuCards"
                        class="col-md-9 col-lg-9 col-sm-12"
                >

                    <div
                            v-if="menu.hasOwnProperty('macro') &&  menu && menu.macro && menu.macro[0]"
                            class=" clearfix  img-responsive hidden-xs"
                            style="margin-bottom: 50px !important"
                    >
                        <img
                                v-if="menu.macro[0].banner && menu.macro[0].banner.url"

                                :src="'/' + menu.macro[0].banner.url + '?fit=fill'"/>
                        <div style="margin-top: 15px">
                            <p class="text-left" v-html="menu.macro[0].description">
                            </p>
                        </div>
                    </div>
                    <ul class="products categoryProduct auto-clear">
                        <li
                                class="product-item col-lg-4 col-md-4 col-sm-6 col-xs-12 style-1 "
                                style="padding:2px !important;"
                                is="menu-card-item"
                                v-for="(menu, index) in menuCards"
                                v-bind:key="menu.id"
                                v-bind:menu="menu"
                                v-bind:type="menu.type"
                                v-bind:queryParams="queryParams"
                        ></li>
                    </ul>
                </div>

                <div
                        v-if="showProductsList()"
                        class="col-md-9 col-lg-9 col-sm-12"
                >


                    <div
                            v-if="!brandNavigation && queryParams.category && menu &&
                             menu.hasOwnProperty('categories_groups') &&
                             menu.categories_groups && menu.categories_groups[0].background && menu.categories_groups[0].background.url"
                            class="banner-catalog clearfix  img-responsive"
                            style="margin-bottom: 50px !important"
                    >
                        <img :src="'/' + menu.categories_groups[0].background.url + '?fit=fill'"/>

                        <div style="margin-top: 15px">
                            <p class="text-left" v-html="menu.categories_groups[0].content">
                            </p>
                        </div>

                    </div>
                    <div
                            v-if="brandNavigation &&
                            queryParams.brand &&
                            menu &&
                            menu.hasOwnProperty('brands') &&
                            menu.brands && menu.brands[0].banner && menu.brands[0].banner.url"

                            class="banner-catalog clearfix img-responsive"
                            style="margin-bottom: 50px !important"
                    >

                        <div class="text-center">

                            <img :src="'/' + menu.brands[0].banner.url + '?fit=fill'" class="img-responsive"/>
                        </div>

                        <div style="margin-top: 15px">
                            <p class="text-left" v-html="menu.brands[0].content">
                            </p>
                        </div>

                    </div>


                    <div class="w100 productFilter clearfix">
                        <div class="col-xs-8">
                            <p>
                                <small>
                                    {{ $t('message.Pagina') }} {{pager.page}}
                                    {{ $t('message.di') }} {{pager.pageCount}},
                                    {{ $t('message.vedi') }} {{pager.perPage > pager.count
                                    ?
                                    pager.count : pager.perPage}}
                                    {{ $t('message.di') }} {{pager.count}}
                                    {{ $t('message.totali') }}
                                </small>
                            </p>
                        </div>
                        <div class="col-sm-4 hidden-xs">
                            <div class="change-view pull-right">
                                <a href="#" title="Grid" class="grid-view" v-on:click="changeViewMode('grid-view')">
                                    <i class="fa fa-th-large"></i>
                                </a>
                                <a href="#" title="List" class="list-view " v-on:click="changeViewMode('list-view')">
                                    <i class="fa fa-th-list"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-xs-12">
                        <div
                                class="toolbar-products clear-both">

                            <div style="clear: both"></div>

                            <div class="tagcloud" style="margin-bottom: 50px">
                            <span v-if="queryParams.keyword"
                                  v-on:click="removeFilter('keyword')"
                                  class="btn btn-sm btn-info"
                                  style="margin-right: 5px;"
                            >
                                <strong>
                                    <small>
                                    {{ $t('message.cerca') }} &raquo;</small>
                                    {{queryParams.keyword}} &nbsp;
                                </strong>
                                <i class="fa fa-times pull"></i>
                                </span>
                                </span>
                                <span v-for="(chip, index) in Object.keys(chipsEnabled)"
                                      v-if="queryParams[chip] && menu"
                                      v-on:click="removeFilter(chip)"
                                      class="btn btn-sm btn-primary"
                                      style="margin-right: 5px;"
                                >

                                <strong>
                                    <small>{{chipsEnabled[chip].name}} &raquo;</small>
                                    {{getChipTranslation(queryParams[chip])}} &nbsp;
                                </strong>
                                <i class="fa fa-times pull"></i>
                                </span>
                                </span>

                                <span v-if="queryParams.minPrice"
                                      v-on:click="removeFilter('minPrice');removeFilter('maxPrice');"
                                      class="btn btn-sm btn-primary"
                                      style="margin-right: 5px;"
                                >
                                <strong>
                                    <small>Prezzo &raquo;</small>
                                    {{queryParams.minPrice}} - {{queryParams.maxPrice}} &nbsp;
                                </strong>
                                <i class="fa fa-times pull"></i>
                                </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                            class="main-content"
                            style="width: 100%"
                    >

                        <div
                                v-if="products.length == 0 && !isLoading"
                        >

                            <p class="alert alert-info" style="clear: both">
                                {{ $t('message.Nessun prodotto trovato') }}
                            </p>

                        </div>

                        <div
                                v-if="products.length == 0 && isLoading"
                        >
                            <p class="alert alert-info" style="clear: both">
                                {{ $t('message.Caricamento prodotti in corso') }}
                            </p>
                        </div>

                        <ul
                                class="products categoryProduct auto-clear"
                        >
                            <li
                                    class="product-item col-lg-4 col-md-4 col-sm-6 col-xs-12 style-1 "
                                    is="product-item"
                                    v-for="(product, index) in products"
                                    v-bind:key="product.id"
                                    v-bind:product="product"
                                    v-bind:locale="locale"
                                    :viewmode="viewmode"
                            ></li>
                        </ul>
                        <div style="clear: both"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="w100 categoryFooter">
                        <nav class="pagination no-margin-top pull-right">
                            <pagination
                                    v-if="showProductsList() && pager.pageCount > 1"
                                    :total-pages="pager.pageCount"
                                    :total="pager.count"
                                    :per-page="pager.perPage"
                                    :current-page="currentPage"
                                    @pagechanged="onPageChange"
                            />
                        </nav>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import Vue from 'vue'
    import VueSlider from 'vue-slider-component'

    import MenuItem from './components/MenuItem';
    import MenuCardItem from './components/MenuCardItem';
    import ProductItem from './components/ProductItem';
    import Pagination from './components/Pagination';

    Vue.use(Loading);
    Vue.component('loading', Loading);

    Vue.filter('striphtml', function (value) {
        var div = document.createElement("div");
        div.innerHTML = value;
        var text = div.textContent || div.innerText || "";
        return text;
    });

    export default {
        name: 'app',
        components: {
            MenuItem,
            MenuCardItem,
            VueSlider,
            ProductItem,
            Pagination
        },
        computed: {
            isLoading() {
                return (this.isLoadingCards || this.isLoadingMenu || this.isLoadingProducts);
            },
        },
        data() {
            return {
                locale: this.$i18n.locale,
                browserDetect: this.$browserDetect,
                viewmode: localStorage.getItem('viewmode') ? localStorage.getItem('viewmode') : 'grid-view',
                minPrice: 1,
                maxPrice: 100,
                startPrice: null,
                endPrice: null,
                priceSearch: [
                    1, 100
                ],
                isLoadingMenu: false,
                isLoadingProducts: false,
                isLoadingCards: false,
                fullPage: true,
                brandNavigation: false,
                showTopWidget: false,
                queryParams: {
                    lang: this.$route.params['lang'],
                    top: this.$route.params['top'] && this.$route.params['top'] !== 'catalog' ? this.$route.params['top'] : this.$route.query['top'],
                    category: this.$route.params['category'] ? this.$route.params['category'] : this.$route.query['category'],
                    group: this.$route.params['group'] ? this.$route.params['group'] : this.$route.query['group'],
                    brand: this.$route.params['brand'] ? this.$route.params['brand'] : this.$route.query['brand'],
                    gender: this.$route.query['gender'],
                    keyword: this.$route.query['keyword'],
                    //limit: this.$route.query['limit'] ? this.$route.query['limit'] : config.limit,
                    //direction: this.$route.query['direction'] ? this.$route.query['direction'] : config.direction,
                    //sort: this.$route.query['sort'] ? this.$route.query['sort'] : config.sort,
                    page: this.$route.query['page'] ? this.$route.query['page'] : 1,
                    pageCount: this.$route.query['pageCount'] ? this.$route.query['pageCount'] : 1,
                    //is_brand_navigation: false

                },
                chipsEnabled: {
                    'top': {
                        'name': 'Area',
                        'asMenu': 'macro'
                    },
                    'category': {
                        'name': 'Categoria',
                        'asMenu': 'categories_groups'
                    },
                    'group': {
                        'name': 'Sotto categoria',
                        'asMenu': 'categories_groups'
                    },
                    'brand': {
                        'name': 'Marchio',
                        'asMenu': 'brands'
                    },
                    'gender': {
                        'name': 'Genere',
                        'asMenu': 'genders'
                    },
                    'season': {
                        'name': 'Stagione',
                        'asMenu': 'seasons'
                    }
                },
                menuCache: [],
                chipsTranslated: [],
                products: [],
                menu: {},
                menuCards: [],
                pager: {
                    "finder": "all",
                    "page": 1,
                    "current": 1,
                    "count": 1,
                    "perPage": 12,
                    "start": 1,
                    "end": 12,
                    "prevPage": false,
                    "nextPage": true,
                    "pageCount": 1,
                    "sort": "sku",
                    "direction": "asc",
                    "limit": null,
                    "sortDefault": 0,
                    "directionDefault": "Products.id DESC",
                    "scope": null,
                    "completeSort": {
                        "Products.sku": "asc",
                        "0": "Products.id DESC"
                    }
                },
                currentPage: this.$route.query['page'] ? this.$route.query['page'] : 1,
                keyword: null,
            }
        },
        methods: {
            showProductsList() {
                return (
                        !!((
                                this.queryParams.category
                                &&
                                this.queryParams.category.length
                            )
                            ||
                            (
                                this.queryParams.brand
                                &&
                                this.queryParams.brand.length
                            )))

                    || (this.queryParams.keyword != null && this.queryParams.keyword.length)
                    ;
            },
            showTopMenu() {
                this.showTopWidget = !!(
                    (this.brandNavigation ? true : false) ||
                    (this.queryParams.keyword && this.queryParams.keyword.length) ||
                    (!this.queryParams.top || this.queryParams.top == null)
                );
                return this.showTopWidget;
            },
            checkBrandNavigation() {
                this.brandNavigation = this.$route.meta.brandNavigation;
                //this.queryParams.is_brand_navigation = this.brandNavigation ? 1 : 0;
                return false;
            },
            getChipTranslation: function (chipKey) {
                let menuCache = this.menu;

                if (menuCache != 'undefined' &&
                    menuCache instanceof Object &&
                    menuCache.hasOwnProperty('categories_groups')
                ) {

                    const chipsEnabledAsArray = Object
                        .keys(this.chipsEnabled)
                        .map(i => this.chipsEnabled[i].asMenu)
                    ;

                    const chipsTranslated = [];
                    chipsEnabledAsArray.forEach(function (chip) {
                        if (typeof menuCache[chip] !== "undefined" && menuCache[chip].length && menuCache[chip][0]) {
                            menuCache[chip]
                                .map(function (item) {
                                    this.chipsTranslated["" + (item.slug ? item.slug : item.code)] = item.name ? item.name : item.description;
                                    return {[(item.slug ? item.slug : item.code)]: item.name ? item.name : item.description};
                                }.bind(this));

                            let chipsWithChild =
                                menuCache[chip]
                                    .filter(function (child) {
                                        return child.products_groups;
                                    });

                            chipsWithChild.forEach(function (chipTest) {
                                chipsTranslated["" + chipTest.slug] = chipTest.name ? chipTest.name : chipTest.description;
                                if (chipTest.hasOwnProperty('products_groups')) {
                                    chipTest.products_groups.forEach(function (chipChildTest) {
                                        chipsTranslated["" + (chipChildTest.slug ? chipChildTest.slug : chipChildTest.code)] = chipChildTest.name ? chipChildTest.name : chipChildTest.description;
                                    });
                                }

                            });
                        }
                    }, this);

                    this.chipsTranslated = Object.assign(this.chipsTranslated, chipsTranslated);
                }
                return this.chipsTranslated[chipKey];
            },
            changeViewMode(type) {
                this.viewmode = type;
                localStorage.setItem('viewmode', type);
            },
            removeFilters: function (types) {
                types.forEach(function (type) {
                    this.queryParams[type] = null;
                    if (type === 'category') {
                        this.queryParams["group"] = null;
                    }
                }, this);
                this._setRoute();
            },
            removeFilter: function (type) {
                this.queryParams[type] = null;
                if (type === 'category') {
                    this.queryParams["group"] = null;
                }

                this._setRoute();
            },
            addFilterEvent: function (filter, type, parent) {

                let queryFilter = {
                    [filter.filter.key]: filter.filter.slug ? filter.filter.slug : filter.filter.code
                };

                if (typeof parent !== 'undefined') {
                    queryFilter = {[parent.key]: parent.slug ? parent.slug : parent.code, ...queryFilter}
                }

                this.queryParams = {...this.queryParams, ...queryFilter};
                this.currentPage = 1;
                this.queryParams = {...this.queryParams, ...{page: this.currentPage}};

                this._setRoute();
            },
            addFilters: function (filters) {
                filters.forEach((filter) => {

                    let queryFilter = {
                        [filter.key]: filter.slug ? filter.slug : filter.code
                    };

                    if (typeof parent !== 'undefined') {
                        queryFilter = {[parent.key]: parent.slug ? parent.slug : parent.code, ...queryFilter}
                    }


                    this.queryParams = {...this.queryParams, ...queryFilter};
                    this.currentPage = 1;
                    this.queryParams = {...this.queryParams, ...{page: this.currentPage}};

                });


                this._setRoute();
            },
            buildUrl: function (filter, type, parent) {

                let queryFilter = {
                    [filter.key]: filter.slug ? filter.slug : filter.code
                };

                if (typeof parent !== 'undefined') {
                    queryFilter = {[parent.key]: parent.slug ? parent.slug : parent.code, ...queryFilter}
                }

                let queryParams = {...this.queryParams, ...queryFilter};


                return '/' + queryParams.lang + '/' + queryParams.top + '/' + queryParams.category + (queryParams.group ? '/' + queryParams.group : '');
            },
            changePrices() {

                this.addFilterEvent({
                        filter: {
                            key: 'minPrice',
                            code: this.$refs.slider.value[0]
                        }
                    }
                );

                this.addFilterEvent({
                    filter: {
                        key: 'maxPrice',
                        code: this.$refs.slider.value[1]
                    }

                });

            },
            onPageChange(page) {
                this.currentPage = page;
                this.queryParams['page'] = this.currentPage;
                this._setRoute();
            },
            _fetchMenu() {
                this.isLoadingMenu = true;
                this.axios
                    .get('/acm3-ecommerce/api/menu', {
                        params: this.queryParams
                    })
                    .then(response => {
                        this.menuCache = response.data.menu_array;
                        this.isLoadingMenu = false;
                    });
            },
            _setRoute() {
                let filters = {...this.queryParams, ...{timestamp: (new Date()).toLocaleTimeString()}};

                this.$router.push({
                    path: this.buildPathUrl(),
                    query: filters
                });
            },
            _fetchItems() {
                this.isLoadingProducts = true;

                if (this.queryParams.page === 1) {
                    this.products = [];
                }

                this.axios
                    .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/products', {
                        params: this.queryParams
                    })
                    .then(response => {
                        this.products = [];
                        this.products = response.data.products;
                        this.pager = response.data.pager;

                        this.queryParams.pageCount = this.pager.pageCount;

                        this.currentPage = response.data.pager.page;
                        this.menu = response.data.menu_array;
                        this.chipsEnabled = response.data.menu_array.chips_translated;
                        this.menu.macro = [
                            this.menu.macro
                        ];

                        this.menuCards = response.data.menu_array.categories_groups;

                        if (response.data.menu_array.hasOwnProperty('price')) {
                            this.price = response.data.menu_array.price;

                            let minAbsolute = this.price.minAbsolute,
                                maxAbsolute = this.price.maxAbsolute,
                                minPrice = this.price.min,
                                maxPrice = this.price.max
                            ;

                            if (this.price.min < this.price.minAbsolute) {
                                minAbsolute = this.price.min;
                                minPrice = this.price.minAbsolute;
                            }
                            if (this.price.max > this.price.maxAbsolute) {
                                maxAbsolute = this.price.max;
                                maxPrice = this.price.maxAbsolute;
                            }

                            this.minPrice = minPrice;
                            this.maxPrice = maxPrice;

                            this.endPrice = maxAbsolute;
                            this.startPrice = minAbsolute;

                            this.priceSearch = [];

                            this.priceSearch[0] = minPrice;
                            this.priceSearch[1] = maxPrice;
                        }
                        /*
                                                if (
                                                    this.price &&
                                                    (this.price['min'] || this.price['min'] === 0) &&
                                                    this.price['max']
                                                ) {

                                                }
                        */
                        this.isLoadingProducts = false;

                        window.scrollTo(0, 0);
                        this.showTopMenu();
                    });
            },
            _fetchCards() {
                this.isLoadingCards = true;

                this.axios
                    .get('/acm3-ecommerce/api/category', {
                        params: this.queryParams
                    })
                    .then(response => {
                        if (response.data && response.data.hasOwnProperty('categories')) {
                            this.menuCards = response.data.categories;
                        }
                        this.isLoadingCards = false;
                    });
            },
            buildPathUrl() {

                if (this.queryParams.top && this.queryParams.category && this.queryParams.group) {
                    return '/' + this.queryParams.lang + '/' + this.queryParams.top + '/' + this.queryParams.category + '/' + this.queryParams.group;
                }

                if (this.queryParams.top && this.queryParams.category) {
                    return '/' + this.queryParams.lang + '/' + this.queryParams.top + '/' + this.queryParams.category + (this.queryParams.group ? '/' + this.queryParams.group : '');
                }

                if (this.queryParams.top) {
                    return '/' + this.queryParams.lang + '/' + this.queryParams.top;
                }

                return '/' + this.queryParams.lang + '/catalog';
            }
        },
        watch: {
            $route(to) {
                if (Object.keys(to.query).length === 0 && to.query.constructor === Object) {
                    location.href = document.location;
                } else {
                    this.queryParams = to.query;
                    this._fetchItems();
                }

            }
        },
        created() {

            const BASE_URL = `${process.env.VUE_APP_API_BASE_URL}`;

            const CONFIG = {
                baseURL: BASE_URL,
                headers: {
                    Authorization: '',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                /*
                transformRequest: [
                    addAuthToken,
                ],
                */
            };

            this.axios.create(CONFIG);
        },
        mounted() {
            this.$i18n.locale = this.$route.params.lang;
            this.menu = {};

            this.checkBrandNavigation();
            this.showTopMenu();
            this.menuCards = [];

            var self = this;
            setTimeout(function () {
                self._fetchItems()
            }, 100);
        },

    }


    import 'vue-loading-overlay/dist/vue-loading.css';

</script>


<style lang="scss">

    $themeColor: #1daf4d;
    @import '~vue-slider-component/lib/theme/default.scss';

    /*
        #app {
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: center;
            color: #2c3e50;
            margin-top: 60px;
        }
     */

</style>
